module.exports = __webpack_public_path__ + "img/notice_banner.f1f65991.png";